/** @jsx jsx */
import { css, jsx } from '@emotion/react';

// NOTE: This should only be added as a child of <VideoProgressBar>
// There is a separate file mainly for organization purposes -
// separating files helps keep the logic in each more focused.

const styles = {
  progressBarMarker: (leftOffsetPercent: string, color = '') => css`
    position: absolute;
    height: 100%;
    width: 4px;
    background-color: ${color};
    top: 0;
    transform: translate(-50%, 0%);
    z-index: 99;
    left: ${leftOffsetPercent};

    @media (forced-colors: active) {
      background-color: ButtonText;
    }
  `,
  modernProgressBarMarker: `
  background-color: var(--cds-color-yellow-500)
  `,
};

type Props = {
  offsetFraction: number;
  color?: string;
};

const ProgressBarMarker = ({ offsetFraction, color }: Props) => {
  const formattedOffset = `${(Math.floor(offsetFraction * 10000) / 100).toFixed(2)}%`;
  return (
    <div
      css={[styles.progressBarMarker(formattedOffset, color), styles.modernProgressBarMarker]}
      className="rc-ProgressBarMarker"
      data-testid="progress-bar-marker"
    />
  );
};

export default ProgressBarMarker;
